<template>
    <va-create-layout>
        <RefundEventOrderFee-form
            :title="title"
            :item="item"
        ></RefundEventOrderFee-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
